<template>
  <div class="overlay" :class="isActive">
    <!-- Overlay content -->
    <div class="overlay-content">
      <router-link class="has-text-light" to="/">
        Home
      </router-link>
      <a class="has-text-light" href="https://steemit.com/@lnakuma" target="_blank">
        Steemit
      </a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isActive() {
      return (this.$store.state.Expands.Menu) ? "is-active" : ""
    }
  },
  name: "Menu"
}
</script>

<style scoped>
/* The Overlay (background) */
.overlay {
  background-color: rgb(0,0,0); /* Black fallback color */
  background-color: rgba(0,0,0, 0.95); /* Black w/opacity */
  /* Height & width depends on how you want to reveal the overlay (see JS below) */
  height: 100%;
  width: 0;
  overflow-x: hidden; /* Disable horizontal scroll */
  position: fixed; /* Stay in place */
  right: 0;
  top: 0;
  transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
  z-index: 1; /* Sit on top */
}
.overlay.is-active {
  width: 100%;
}
/* Position the content inside the overlay */
.overlay-content {
  position: relative;
  top: 25%; /* 25% from the top */
  width: 70%; /* 100% width */
  text-align: left; /* Centered text/links */
  margin: 30px auto; /* 30px top margin to avoid conflict with the close button on smaller screens */
}
/* The navigation links inside the overlay */
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block; /* Display block instead of inline */
  transition: 0.3s; /* Transition effects on hover (color) */
}
/* When you mouse over the navigation links, change their color */
.overlay a:hover, .overlay a:focus {
  color: #f1f1f1;
}
/* Position the close button (top right corner) */
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
/* When the height of the screen is less than 450 pixels, change the font-size of the links and position the close button again, so they don't overlap */
@media screen and (max-height: 450px) {
  .overlay a {font-size: 20px}
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
</style>
